<template>
  <div class="sidebar">
    <div class="vuestic-scrollbar">
      <div class="scrollbar-content">
        <ul class="sidebar-menu">
          <li>
            <auth-link
              :to="'/brands/' + activeBrand.uuid + '/sites/' + activeSiteSlug + '/pages'"
              class="sidebar-link"
              permission="page-index-by-site"
            >
              <i class="sidebar-menu-item-icon vuestic-icon vuestic-icon-files"/>
              Pages
            </auth-link>
          </li>
          <li>
            <auth-link
              :to="'/brands/' + activeBrand.uuid + '/sites/' + activeSiteSlug + '/layouts'"
              class="sidebar-link"
              permission="layout-index"
            >
              <i class="sidebar-menu-item-icon fa fa-file-code-o"/>
              Layouts
            </auth-link>
          </li>
          <li>
            <auth-link
              :to="'/brands/' + activeBrand.uuid + '/sites/' + activeSiteSlug + '/site-importer'"
              class="sidebar-link"
              permission="developer"
            >
              <i class="sidebar-menu-item-icon fa fa-upload"/>
              Site importer
            </auth-link>
          </li>
          <li>
            <auth-link
              :to="'/brands/' + activeBrand.uuid + '/sites/' + activeSiteSlug + '/site-settings'"
              class="sidebar-link"
              permission="site-update"
            >
              <i class="sidebar-menu-item-icon fa fa-gear"/>
              Site settings
            </auth-link>
          </li>
          <li>
            <auth-link
              :to="'/brands/' + activeBrand.uuid + '/sites/' + activeSiteSlug + '/components'"
              class="sidebar-link"
              permission="component-index"
            >
              <i class="sidebar-menu-item-icon fa fa-th"/>
              Components
            </auth-link>
          </li>
          <li>
            <auth-link
              :to="'/brands/' + activeBrand.uuid + '/sites/' + activeSiteSlug + '/translations'"
              class="sidebar-link"
              permission="translation-index"
            >
              <i class="sidebar-menu-item-icon fa fa-globe"/>
              Translations
            </auth-link>
          </li>
          <li>
            <auth-link
              :to="'/brands/' + activeBrand.uuid + '/sites/' + activeSiteSlug + '/groups/pages'"
              class="sidebar-link sidebar-submenu-link"
              permission="page-group-index"
            >
              <i class="sidebar-menu-item-icon vuestic-icon vuestic-icon-files"/>
              Page groups
            </auth-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SidebarMain',
  computed: {
    ...mapGetters({
      activeBrand: 'brand/active',
      activeSite: 'site/active'
    }),
    activeSiteSlug () {
      return this.activeSite ? this.activeSite.slug : ''
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/scss/_variables.scss";
@import "~bootstrap/scss/mixins/breakpoints";
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";

.sidebar {
  @include media-breakpoint-down(md) {
    top: $sidebar-mobile-top;
    left: $sidebar-mobile-left;
    width: $sidebar-mobile-width;
    z-index: $sidebar-mobile-z-index;
  }

  height: $sidebar-viewport-height;
  .vuestic-scrollbar {
    height: 100%;
    .scrollbar-wrapper {
      box-shadow: $sidebar-box-shadow;
    }
    .scrollbar-content {
      background: $sidebar-bg;
    }
  }

  width: $sidebar-width;
  top: $sidebar-top;
  left: $sidebar-left;
  transition: all 0.2s ease;
  opacity: 1;

  .sidebar-hidden_without-animation & {
    transition: none;
  }

  .sidebar-hidden & {
    @include media-breakpoint-down(md) {
      top: $sidebar-hidden-top-mobile;
      opacity: 0;
      z-index: $sidebar-mobile-z-index;
      height: $sidebar-hidden-height-mobile;
    }
    top: $sidebar-hidden-top;
    opacity: 0;
    z-index: $min-z-index;
  }

  .sidebar-link {
    position: relative;
    height: $sidebar-link-height;
    padding-left: $sidebar-link-pl;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    text-decoration: none;

    &.router-link-active,
    &:hover {
      color: $white;
      background-color: $sidebar-link-active-bg;

      .sidebar-menu-item-icon,
      .expand-icon {
        color: $white;
      }
    }

    .expand-icon {
      position: absolute;
      right: $sidebar-arrow-right;
      top: calc(50% - #{$font-size-root}/2);
      font-weight: bold;
      transition: transform 0.3s ease;
    }

    &.expanded {
      .expand-icon {
        transform: rotate(180deg);
      }
    }

    .sidebar-menu-item-icon {
      font-size: $sidebar-menu-item-icon-size;
      color: $vue-blue;
      margin-right: 14px;
    }
  }

  .sidebar-submenu-link {
    height: $sidebar-submenu-link-height;
  }

  .sidebar-menu,
  .sidebar-submenu {
    list-style: none;
    padding-left: 0;

    li {
      display: block;
      padding-left: 0;
    }
  }

  .sidebar-submenu {
    .sidebar-link {
      padding-left: $sidebar-submenu-link-pl;
      font-size: $font-size-smaller;
      &.disabled {
        text-decoration: line-through;
      }
    }
  }

  .sidebar-menu {
    max-height: 100%;
    margin-bottom: 0;
    li {
      padding-left: 10px;
      a {
        -webkit-transition: background 220ms ease-in-out;
        -moz-transition: background 220ms ease-in-out;
        -ms-transition: background 220ms ease-in-out;
        -o-transition: background 220ms ease-in-out;
        transition: background 220ms ease-in-out;
      }
    }
  }

  .expand-icon {
    color: $vue-blue;
  }

  a {
    color: $white;
    text-decoration: none;
  }
}
</style>
